import React from "react";
import ReactDOM from "react-dom";
import Footer from "../../components/common/footer";
import AdIframeTs from "@Components/ad/adIframeTs";
import AdIframeImage from "@Components/ad/AdFrame_v2";
import WebsiteNav from "@Components/websiteNav";
import "@Styles/base.css";

const $tcNav = document.getElementById("tcTopNav");

$tcNav &&
  ReactDOM.render(
    <>
      <WebsiteNav>
        <div style={{
          width: "1190px",
          height: "120px",
          margin: "0 auto",
          position: "relative",
          background: "#9e9e9e",
        }}>
          <AdIframeImage
            slot={"/173427088/newcar-pc-homepage-topbanner"}
            styles={{ width: "1190px", height: "120px" }}
            size={[["fluid"], [1190, 120]]}
            width={1190}
            height={120}
          />
        </div>
      </WebsiteNav>
    </>,
    $tcNav,
  );

const $footer = document.getElementById("footer");

$footer && ReactDOM.render(<Footer />, $footer);
